<template>
  <div class="record-btn" @click="openRecordPage">
    <img src="@/assets/img/icon/record.png" alt="" />
    <span>{{ $ln('記錄') }}</span>
  </div>
</template>

<script>
import { getRecordURL } from '@/service/api/record'
import { mapState } from 'vuex'

export default {
  name: 'record',
  computed: {
    ...mapState({
      language: state => state.app.language,
      identity: state => state.user.identity
    })
  },
  methods: {
    /**
     * 開啟下注記錄網址
     * @returns {Promise<void>}
     */
    async openRecordPage() {
      if (this.identity === 'guest') {
        this.$message({
          message: this.$ln('試玩模式暫不提供注單查詢')
        })
        return
      }
      if (localStorage.getItem('grpc-session') === null) return
      const res = await getRecordURL(this.language)
      if (res.code === 200 && res.result.result.code === 1) {
        const url = res.result.url
        this.$store.dispatch('url/setBetDetail', url)
        console.log('res.result.url', url)
      } else {
        this.$message({
          message: `${res.result.result.msg}` + ` (${res.result.result.code})`,
          type: 'error'
        })
      }
    }
  }
}
</script>

<style scoped></style>
